import "../css/Print.css"

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

import { Link, Outlet } from 'react-router-dom';
import { cyan, orange } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import { Fragment, useState } from 'react';

import { SYSTEM_PATH_COMPANY } from "../App";
import DeveloperMenu from "../components/DevelopMenu";

const divider_style ={marginLeft: 1, marginRight: 1}

const companyHeaderMenuContents = [
  {
    title:"基本価格表",
    items: [
      {title: "基本価格表", path: "/basic_price"},
      {title: "基本価格表 編集", path: "/basic_price_edit"}
    ]
  },
  {
    title:"市況価格表",
    items: [
      {title: "市況価格表"},
      {title: "市況価格表 編集", path: "/market_price_edit"},
      {title: "注文票確認", path: "/order_form_confirm"}
    ]
  },
  {
    title:"発注",
    items: [
      {title: "取引先受注確認", path: "/order_data_check"},
      {title: "発注振分", path: "/supplier_order_division"},
    ]
  },
  {
    title:"管理",
    items: [
      {title: "取引先検索", path: "/customer_search"},
      {title: "新規取引先登録", path: "/customer_registration"},
      {title: "取引先送信グループ管理", path: "/customer_send_group_list"},
      {title: "新規取引先送信グループ作成", path: "/customer_send_group_registration"},
      {title: "仕入先検索", path: "/supplier_search"},
      {title: "新規仕入先登録", path: "/supplier_registration"},    
      {title: "商品マスタ", path: "/product_master"},
      {title: "営業カレンダー", path: "/market_calendar"},  
    ]
  }
]

const customerHeaderMenuContents = [
  {
    title:"注文",
    items: [
      {title: "注文表作成", path: "/order_system/customer/order_edit"}
    ]
  }
]

function HeaderPopper(props) {

  return (
    <Popper
      anchorEl={props.anchorEl}
      open={props.open}
      onBlur={props.onClose}
      onMouseOver={props.onMouseOver}
      onMouseLeave={props.onMouseLeave}
      sx={{zIndex: 101}}  
    >
      <Paper>
        <Box>
          <List>
            {
              props.items.map((item) => (
                <ListItem key={`menulink-${item.title}`}>
                  {
                    item.path ? <Link onClick={props.onClose} to={SYSTEM_PATH_COMPANY + item.path}>{item.title}</Link>
                      : item.title
                  }                  
                </ListItem>
              ))
            }
          </List>
        </Box>
      </Paper>
    </Popper>
  )
}

function HeaderMenu(props) {

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuContentPosition, setMenuContentPosition] =useState(0)
  const [menuPopperMouseOver, setMenuPopperMouseOver] = useState(false)

  const handleClickMenu = (contPos) => ((event) => {
    setMenuContentPosition(contPos)
    setAnchorEl(event.currentTarget);
  });

  const handleCloseMenu = (event) => {
    setAnchorEl(null)
  }

  const handleMenuPopperMouseOver = (event) => {
    setMenuPopperMouseOver(true)
  }

  const handleMenuPopperMouseLeave = (event) => {
    setMenuPopperMouseOver(false)
  }

  const handleBlurMenu = (event) => {
    if (!menuPopperMouseOver) {
      handleCloseMenu(event)
    }
  }

  return (
    <Box marginLeft={2}>
      <Grid container alignItems='center'>
        {
          props.headerMenuContents.map((content, index) => (
            <Fragment key={`headermenu-${content.title}`}>
              {index > 0 ?<Divider orientation="vertical" variant="middle" flexItem sx={divider_style}/> : null}
              <Grid item xs='auto'>                
                <Button onClick={handleClickMenu(index)} onBlur={handleBlurMenu} sx={{fontSize: 16}}>{content.title}</Button>
                <HeaderPopper
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl) && menuContentPosition === index}
                  onClose={handleCloseMenu}
                  onMouseOver={handleMenuPopperMouseOver}
                  onMouseLeave={handleMenuPopperMouseLeave}
                  items={content.items}
                />
              </Grid>
            </Fragment>
          ))
        }
      </Grid>
    </Box>
  )
}

export const PRINT_MODE_INCLUDE_HEADER = 0;
export const PRINT_MODE_EXCLUDE_HEADER = 1;

function CommonSiteHeader(props) {
  const [printMode, setPrintMode] = useState(PRINT_MODE_INCLUDE_HEADER);

  return (
    <Box>
      <Box
        position="sticky" top={0} left={0}
        width="100%" backgroundColor={props.backgroundColor} boxShadow={2}
        sx={{zIndex: 100}}
      >
        <Box padding={1} className={printMode === PRINT_MODE_EXCLUDE_HEADER ? "print_exclude" : ""}>
          <Grid container alignItems='center'>
            <Grid item xs='auto'>
              <Typography marginRight={5} fontSize={28}>
                注文システム
              </Typography>
            </Grid>
            <Grid item xs>
              <HeaderMenu headerMenuContents={props.menuContents} />  
            </Grid>
            <Grid item xs='auto'>
              <Box>
                <Grid container spacing={1} alignItems='center'>
                  <Grid item xs='auto'>
                    <Typography fontWeight={600} fontSize={14}>ID: xxxx</Typography>
                  </Grid>
                  <Grid item xs="auto">
                    <Typography fontSize={12}>としてログイン中</Typography>
                  </Grid>
                </Grid>                 
                <Typography fontWeight={600} fontSize={12}><Link to="/">ログアウト</Link></Typography>
              </Box>
            </Grid>
            <Divider orientation="vertical" variant="middle" flexItem sx={divider_style}/>
            <Grid item xs='auto'>
        
              <Typography marginRight={1} textAlign='right' fontSize={16}>
                {props.sideText}
              </Typography>
            </Grid>
          </Grid>          
        </Box>        
      </Box>
      <Box>
        <Outlet context={{ printMode, setPrintMode }}/>
      </Box>      
    </Box>
  );  
}


// 青果側サイト　ヘッダ
export function CompanySiteHeader(props) {

  return (
    <CommonSiteHeader
      backgroundColor={orange[100]}
      menuContents={companyHeaderMenuContents}
      sideText="青果側web&nbsp;&nbsp;丸伊伊那青果"
    />
  );
}

// 取引先側サイト　ヘッダ
export function CustomerSiteHeader(props) {

  return (
    <CommonSiteHeader
      backgroundColor={cyan[50]}
      menuContents={customerHeaderMenuContents}
      sideText="取引先様専用web&nbsp;&nbsp;丸伊伊那青果"
    />
  );

}
